import { Check, Loader2, Sparkles } from 'lucide-react'
import { cn } from 'lib/utils'
import { useGenerationPhaseStore } from '../store/generation-phase-store'

/**
 * The live "agent working" ladder: while SocialKit generates or revises a post, it
 * streams its real pipeline beats (deciding the angle, keeping/finding the photo,
 * judging, fixing the weak spot) and this renders them as they happen — so the chat
 * feels like a capable agent at work, not one opaque wait. Hides itself the moment
 * the run finishes; the message's tool result + score chip take over.
 */
export function GenerationSteps({ creativeId }: { creativeId: string }) {
  const state = useGenerationPhaseStore(s => s.byCreative[creativeId])
  if (!state || !state.active || state.steps.length === 0) return null

  return (
    <div className="mb-3 flex flex-col gap-1.5 rounded-[10px] border border-line bg-bg-2 p-3">
      <div className="mb-0.5 flex items-center gap-1.5 text-[11px] font-medium tracking-wide text-paper-faint uppercase">
        <Sparkles size={12} className="text-acid" />
        SocialKit is working
      </div>
      {state.steps.map(step => (
        <div key={step.id} className="flex items-start gap-2 text-[12px]">
          {step.status === 'done' ? (
            <Check size={13} className="text-success mt-[2px] flex-shrink-0" />
          ) : (
            <Loader2 size={13} className="mt-[2px] flex-shrink-0 animate-spin text-acid" />
          )}
          <div className="flex min-w-0 flex-1 flex-col">
            <span className={cn(step.status === 'done' ? 'text-paper-dim' : 'text-paper')}>
              {step.status === 'done' ? (
                step.label
              ) : (
                <span className="shimmer-text">{step.label}</span>
              )}
            </span>
            {step.detail && (
              <span className="truncate text-[11px] leading-snug text-paper-faint">
                {step.detail}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
